import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-4" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  class: "form-control w-25",
  placeholder: "Enter Search Key !"
}, null, -1)
const _hoisted_6 = {
  type: "button",
  class: "btn btn-primary me-1 ms-1"
}
const _hoisted_7 = {
  type: "button",
  class: "btn btn-default border"
}
const _hoisted_8 = { class: "card mb-4 d-none d-md-block" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "table-responsive text-nowrap"
}
const _hoisted_14 = {
  key: 0,
  class: "table card-table"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Id"),
    /*#__PURE__*/_createElementVNode("th", null, "Payment Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Bill"),
    /*#__PURE__*/_createElementVNode("th", null, "Payment"),
    /*#__PURE__*/_createElementVNode("th", null, "Due"),
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1)
const _hoisted_16 = { class: "table-border-bottom-0" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h5", { class: "text-center mb-0" }, "Please Sale Some Product First", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "mobile-view d-block d-md-none" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "card-body" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "text-wrap" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { class: "text-wrap" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = { class: "text-wrap" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "text-center mb-0 text-wrap" }, "Please Sale Some Product First")
  ])
], -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 0,
  class: "card"
}
const _hoisted_36 = { class: "card-body d-flex justify-content-around flex-wrap" }
const _hoisted_37 = { "aria-label": "Page navigation" }
const _hoisted_38 = { class: "pagination" }
const _hoisted_39 = ["onClick", "innerHTML"]
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-12" }
const _hoisted_42 = { class: "input-group" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", {
  class: "input-group-text",
  for: "inputGroupSelect01"
}, "Size", -1)
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<option value=\"10\">10</option><option value=\"20\">20</option><option value=\"30\">30</option><option value=\"40\">40</option><option value=\"50\">50</option><option value=\"100\">100</option>", 6)
const _hoisted_50 = [
  _hoisted_44
]
const _hoisted_51 = {
  class: "modal fade",
  id: "modalCenter",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_52 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_53 = { class: "modal-content" }
const _hoisted_54 = { class: "modal-header" }
const _hoisted_55 = {
  class: "modal-title text-center",
  id: "modalCenterTitle"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_57 = { class: "mb-4" }
const _hoisted_58 = { class: "card-body" }
const _hoisted_59 = { class: "text-wrap" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_61 = { class: "text-wrap" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_63 = { class: "text-wrap" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("strong", null, "Customer Info: ", -1)
const _hoisted_66 = /*#__PURE__*/_createTextVNode()
const _hoisted_67 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_68 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_69 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_70 = {
  key: 2,
  class: "mb-0"
}
const _hoisted_71 = {
  key: 3,
  class: "mb-0"
}
const _hoisted_72 = {
  key: 4,
  class: "mb-0"
}
const _hoisted_73 = {
  key: 5,
  class: ""
}
const _hoisted_74 = /*#__PURE__*/_createTextVNode()
const _hoisted_75 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, " Order Info: ")
], -1)
const _hoisted_77 = {
  key: 6,
  class: "mb-0",
  "data-bs-dismiss": "modal"
}
const _hoisted_78 = /*#__PURE__*/_createTextVNode("Invoice Number: ")
const _hoisted_79 = {
  key: 7,
  class: "mb-0"
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer text-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-outline-secondary",
    "data-bs-dismiss": "modal"
  }, " Close ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("button", _hoisted_6, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'magnifying-glass'] })
            ]),
            _createElementVNode("button", _hoisted_7, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'broom'] })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_ctx.fettchDataArray.length > 0)
                ? (_openBlock(), _createElementBlock("table", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("tbody", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fettchDataArray, (dataItem, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: dataItem.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", null, _toDisplayString(dataItem.payment_type), 1),
                          _createElementVNode("td", null, _toDisplayString(dataItem.bill_total), 1),
                          _createElementVNode("td", null, _toDisplayString(dataItem.payment), 1),
                          _createElementVNode("td", null, _toDisplayString(dataItem.due), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatDateTime (dataItem.created_at)), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "me-2 btn btn-sm btn-primary",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#modalCenter",
                              onClick: ($event: any) => (_ctx.fetchItem(dataItem))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-eye'] })
                            ], 8, _hoisted_17)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      (_ctx.fettchDataArray.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fettchDataArray, (dataItem) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "card mb-4",
                key: dataItem.id
              }, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("strong", null, "Type: " + _toDisplayString(dataItem.payment_type), 1),
                  _hoisted_24,
                  _createElementVNode("span", _hoisted_25, "Total Bill: " + _toDisplayString(dataItem.bill_total), 1),
                  _hoisted_26,
                  _createElementVNode("span", _hoisted_27, "Payment: " + _toDisplayString(dataItem.payment), 1),
                  _hoisted_28,
                  _createElementVNode("span", _hoisted_29, "Due: " + _toDisplayString(dataItem.due), 1),
                  _hoisted_30,
                  _createElementVNode("p", null, "Date: " + _toDisplayString(_ctx.formatDateTime (dataItem.created_at)), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "me-2 btn btn-sm btn-primary",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#modalCenter",
                    onClick: ($event: any) => (_ctx.fetchItem(dataItem))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-eye'] })
                  ], 8, _hoisted_31)
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
    ]),
    (_ctx.fettchDataArray.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("nav", _hoisted_37, [
              _createElementVNode("ul", _hoisted_38, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationData.links, (page, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: _normalizeClass(["page-item myPagination", { active: page.active }])
                  }, [
                    _createElementVNode("button", {
                      class: "page-link",
                      onClick: ($event: any) => (_ctx.goToPage(Number(page.label))),
                      innerHTML: page.label
                    }, null, 8, _hoisted_39)
                  ], 2))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    id: "inputGroupSelect01",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageSize) = $event)),
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fetchData && _ctx.fetchData(...args)))
                  }, _hoisted_50, 544), [
                    [_vModelSelect, _ctx.pageSize]
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("h5", _hoisted_55, "Payment Type: " + _toDisplayString(_ctx.deletevalue.payment_type), 1),
            _hoisted_56
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("span", _hoisted_59, "Total Bill: " + _toDisplayString(_ctx.deletevalue.bill_total), 1),
              _hoisted_60,
              _createElementVNode("span", _hoisted_61, "Payment: " + _toDisplayString(_ctx.deletevalue.payment), 1),
              _hoisted_62,
              _createElementVNode("span", _hoisted_63, "Due: " + _toDisplayString(_ctx.deletevalue.due), 1),
              _hoisted_64,
              _createElementVNode("p", null, "Date: " + _toDisplayString(_ctx.formatDateTime (_ctx.deletevalue.created_at)), 1),
              _hoisted_65,
              _hoisted_66,
              _hoisted_67,
              (_ctx.deletevalue.customer?.name)
                ? (_openBlock(), _createElementBlock("p", _hoisted_68, "Name: " + _toDisplayString(_ctx.deletevalue.customer?.name), 1))
                : _createCommentVNode("", true),
              (_ctx.deletevalue.customer?.phone)
                ? (_openBlock(), _createElementBlock("p", _hoisted_69, "Phone: " + _toDisplayString(_ctx.deletevalue.customer?.phone), 1))
                : _createCommentVNode("", true),
              (_ctx.deletevalue.customer_type)
                ? (_openBlock(), _createElementBlock("p", _hoisted_70, "Customer Type: " + _toDisplayString(_ctx.deletevalue.customer_type), 1))
                : _createCommentVNode("", true),
              (_ctx.deletevalue.customer?.email)
                ? (_openBlock(), _createElementBlock("p", _hoisted_71, "Email: " + _toDisplayString(_ctx.deletevalue.customer?.email), 1))
                : _createCommentVNode("", true),
              (_ctx.deletevalue.customer?.address )
                ? (_openBlock(), _createElementBlock("p", _hoisted_72, "Address: " + _toDisplayString(_ctx.deletevalue.customer?.address), 1))
                : _createCommentVNode("", true),
              (_ctx.deletevalue.customer?.nid_no)
                ? (_openBlock(), _createElementBlock("p", _hoisted_73, "Nid No: " + _toDisplayString(_ctx.deletevalue.customer?.nid_no), 1))
                : _createCommentVNode("", true),
              _hoisted_74,
              _hoisted_75,
              _hoisted_76,
              (_ctx.deletevalue.customer?.name)
                ? (_openBlock(), _createElementBlock("p", _hoisted_77, [
                    _hoisted_78,
                    _createVNode(_component_router_link, {
                      to: `/invoice/${_ctx.deletevalue.order?.id}`,
                      class: "text-decoration-none text-primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.deletevalue.order?.invoice_no), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.deletevalue.order?.total)
                ? (_openBlock(), _createElementBlock("p", _hoisted_79, "Discount: " + _toDisplayString((parseFloat(_ctx.deletevalue.order?.total)?.toFixed(2) - parseFloat(_ctx.deletevalue.order?.sub_total)?.toFixed(2)).toFixed(2)), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_80
        ])
      ])
    ])
  ]))
}